// @mui
import { Box, Container, Stack } from '@mui/material';
// components
import { FeatureWidget, ContactWidget, AllCourseWidget } from '../../sections/web/home';
import { SectionHeader } from '../../sections/web/common';
import { Seo, collectionSchema } from '../../components/seo';
// redux
import { useSelector } from '../../redux/store';

// ----------------------------------------------------------------------

export default function CoursesPage() {
  // AllCourseWidget performs the fetch; this page only reads the result so the
  // ItemList can be emitted from the same data the cards render.
  const { courses } = useSelector((state) => state.course);
  const courseList = Array.isArray(courses) ? courses : courses?.results ?? [];

  return (
    <>
      <Seo
        title="Licensing Exam Preparation Courses UAE"
        description="Browse ASAP licensing exam preparation courses for DHA, MOH, HAAD, OET and other Prometric exams, with lessons, practice material and mentor support."
        path="/courses"
        jsonLd={collectionSchema({
          name: 'Licensing Exam Preparation Courses',
          description:
            'ASAP licensing exam preparation courses for DHA, MOH, HAAD, OET and other Prometric exams.',
          path: '/courses',
          items: courseList
            .filter((course) => course?.name && course?.slug)
            .map((course) => ({ name: course.name, path: `/course/${course.slug}` })),
        })}
      />

      <Container maxWidth="xl" sx={{ py: { xs: 4, md: 6 } }}>
        <Stack spacing={{ xs: 5, md: 8 }}>
          <Box>
            <SectionHeader
              eyebrow="The best choice for your career"
              title="Our Courses"
              titleComponent="h1"
              description="Structured programmes that take you from the official exam blueprint to a confident pass, with lessons, practice material and mentor support."
            />

            <AllCourseWidget />
          </Box>

          <FeatureWidget />

          <ContactWidget />
        </Stack>
      </Container>
    </>
  );
}
